import { definePreset } from '@primeuix/themes';
import Aura from "@primeuix/themes/aura";
import { createPinia } from "pinia";
import 'primeflex/primeflex.css';
import "primeicons/primeicons.css";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
import Ripple from 'primevue/ripple';
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import '@fortawesome/fontawesome-free/css/all.min.css'
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import { useAuthStore } from "./stores/AuthStore";

const MyPreset = definePreset(Aura as any, {
  semantic: {
    primary: {
      50: '#fdf2f4',
      100: '#fce7eb',
      200: '#f8d0d9',
      300: '#f2aab9',
      400: '#e97891',
      500: '#822133',
      600: '#751e2e',
      700: '#681a29',
      800: '#5b1724',
      900: '#4e131f',
      950: '#2d0b12'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f8f9fa',
          100: '#f3f4f6',
          200: '#e5e7eb',
          300: '#d1d5db',
          400: '#9ca3af',
          500: '#6b7280',
          600: '#4b5563',
          700: '#374151',
          800: '#1f2937',
          900: '#111827',
          950: '#030712'
        }
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}'
        }
      }
    }
  }
});

// Locale pt-BR para componentes PrimeVue (DatePicker, Calendar, etc.)
const ptBR = {
  firstDayOfWeek: 0,
  dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
  dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
  monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  today: 'Hoje',
  clear: 'Limpar',
  weekHeader: 'Sem',
  // Rótulos padrão do ConfirmDialog; sem eles, confirm.require sem acceptLabel mostra "Yes/No".
  accept: 'Sim',
  reject: 'Não',
};

const app = createApp(App);

// Diretiva global v-can para verificação de permissões
app.directive("can", (el, binding) => {
  const authStore = useAuthStore();
  const permission = binding.value;

  if (typeof permission === "string" && !authStore.hasPermission(permission)) {
    el.style.display = "none";
  }
});

app.use(createPinia());
app.use(router);
app.use(ToastService);
app.use(ConfirmationService);
app.directive("tooltip", Tooltip);
app.directive('ripple', Ripple);

app.use(PrimeVue, {
  theme: {
    preset: MyPreset,
    options: {
      prefix: "p",
      darkModeSelector: ".dark",
      cssLayer: {
        name: "primevue",
        order: "theme,base,primevue",
      },
    },
  },
  ripple: true,
  inputVariant: "filled",
  locale: ptBR
});

app.component("AppToast", Toast);
app.component("AppConfirmDialog", ConfirmDialog);
app.component('ConfirmDialog', ConfirmDialog);

app.mount("#app");
